<template>
  <div>
    <v-card>
      <v-row>
        <v-col md="12" sm="12" style="text-align: left">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-subtitle class="subtitule subtitule2">{{ $tc("dashboard.menu.eventDetails.membership_setup_desc") }}</v-list-item-subtitle>
              <v-list-item-subtitle class="subtitule">
                <v-dialog v-model="dialog" persistent max-width="670px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ma-2" outlined v-bind="attrs" v-on="on">{{ $tc("dashboard.menu.eventDetails.add_organization") }}</v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ $tc("dashboard.menu.eventDetails.add_organization") }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row v-if="create">
                          <v-col md="9" sm="9">
                            <v-select 
                              v-model="organizationList" 
                              :items="organizationListItems" 
                              item-text="value" 
                              item-value="id" 
                              dense outlined 
                              :label="$tc('dashboard.menu.eventDetails.organizationList')" 
                              return-object
                              :no-data-text="$t('common.no_data')"
                            ></v-select>
                          </v-col>
                          <v-col md="1" sm="1">
                            <v-btn outlined @click="add">
                              {{ $tc("dashboard.menu.eventDetails.add") }}
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-card v-if="items_.length > 0">
                          <v-tabs v-model="tab" grow color="grey darken-1" background-color="transparent">
                            <v-tab v-for="(item, i) in items_" :key="i">{{ item.value }}</v-tab>
                          </v-tabs>
                          <v-tabs-items v-model="tab">
                            <v-tab-item v-for="(item, i) in items_" :key="i">
                              <v-row>
                                <v-col md="3" sm="6">{{ $tc("dashboard.menu.eventDetails.this_information_is") }}</v-col>
                                <v-col md="3" sm="6">
                                  <v-select 
                                    v-model="optionList[i]" 
                                    :items="optionListItems" 
                                    item-text="text" 
                                    item-value="id" 
                                    dense outlined 
                                    return-object
                                    :no-data-text="$t('common.no_data')"
                                  ></v-select>
                                </v-col>
                                <v-col md="6" sm="12" class="d-flex align-center">
                                  <v-checkbox
                                    v-model="forceWaiverSignature[i]"
                                    :label="$tc('dashboard.menu.eventDetails.force_waiver_signature')"
                                    hide-details
                                  ></v-checkbox>
                                </v-col>
                                <v-col v-if="edit_" md="6" sm="12">
                                  <v-btn outlined @click="deleteOrganization">
                                    <v-icon dark>fa-trash-alt</v-icon>
                                    {{ $tc("dashboard.menu.eventDetails.delete_organization") }}
                                  </v-btn>
                                </v-col>
                                <v-col v-if="create" md="6" sm="12">
                                  <v-btn outlined @click="deleteOrgTap">
                                    <v-icon dark>fa-trash-alt</v-icon>
                                    {{ $tc("dashboard.menu.eventDetails.delete_organization") }}
                                  </v-btn>
                                </v-col>
                              </v-row>
                              <v-card>
                                <v-tabs v-model="tab_" grow color="grey darken-1" background-color="transparent">
                                  <v-tab v-for="(item, k) in items_L" :key="k">{{ item }}</v-tab>
                                </v-tabs>
                                <v-tabs-items v-model="tab_">
                                  <v-tab-item v-for="(item, k) in items_L" :key="k" style="text-align: left; padding: 3%">
                                    {{ $tc("dashboard.menu.eventDetails.additional_information") }}
                                    <v-text-field v-model="information[0][k]" solo></v-text-field>
                                  </v-tab-item>
                                </v-tabs-items>
                              </v-card>
                            </v-tab-item>
                          </v-tabs-items>
                        </v-card>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="darken-1" dark small @click="close">{{ $tc("dashboard.menu.eventDetails.close") }}</v-btn>
                      <v-btn color="darken-1" dark small @click="handleSubmit" v-if="create">{{ $tc("dashboard.menu.eventDetails.save_changes") }}</v-btn>
                      <v-btn color="darken-1" dark small @click="editChanges" v-if="edit_">{{ $tc("dashboard.menu.eventDetails.save_changes") }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-list-item-subtitle>
              <v-list-item-subtitle class="subtitule">
                <v-data-table 
                  v-if="eventOrganization != null" 
                  :headers="headers" 
                  :items="eventOrganization" 
                  :items-per-page="6" 
                  group-by="eventOrganizationId" 
                  class="elevation-4" 
                  hide-default-header 
                  :footer-props="{
                        'items-per-page-text': $t('dataTable.rowsPerPageText'),
                        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                  }"
                  :no-data-text="$t('dataTable.noDataText')"
                  :headerProps="{
                    'sort-by-text': $t('dataTable.sortByText')
                  }"
                >
                  <template v-slot:header="{ props: { headers } }">
                    <thead>
                      <tr>
                        <th v-for="(h, i) in headers" :key="i">{{ h.text }}</th>
                      </tr>
                    </thead>
                  </template>
                  <template v-slot:group="{ items }">
                    <tr v-for="(item, index) in items" :key="item.id">
                      <td>{{ item.organizationName }}</td>
                      <td>{{ item.isRequestMemberInfo }}</td>
                      <td>{{ item.isForceWaiverSignature == 1 ? $t('common.yes') : $t('common.no') }}</td>
                      <td v-if="item.language == 1">{{ $tc("dashboard.menu.eventDetails.english") }}</td>
                      <td v-if="item.language == 2">{{ $tc("dashboard.menu.eventDetails.français") }}</td>
                      <td>{{ item.comments }}</td>
                      <td>
                        <v-btn icon @click="edit(items, index)">
                          <v-icon class="mr-2" small>fa fa-pencil-alt</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import Vue from "vue";
import AsyncComputed from "vue-async-computed";

Vue.use(AsyncComputed);

export default {
  mixins: [apiCalls],
  props: ["response"],
  data() {
    return {
      eventOrganization: [],
      organizationListItems: [],
      organizationList: null,
      dialog: false,
      tab: [],
      items_: [],
      tab_: [],
      optionList: [],
      forceWaiverSignature: [],
      information: [],
      count: 0,
      create: true,
      edit_: false,
      itemUpdate: null,
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("dashboard.menu.eventDetails.organization_name"),
          align: "start",
          groupable: false,
          value: "organizationName",
        },
        {
          text: this.$t("dashboard.menu.eventDetails.mandatory-optional"),
          align: "start",
          groupable: false,
          value: "organizationName",
        },
        {
          text: this.$t("dashboard.menu.eventDetails.force_waiver_signature"),
          align: "start",
          groupable: false,
          value: "isForceWaiverSignature",
        },
        {
          text: this.$t("dashboard.menu.eventDetails.language"),
          groupable: false,
          value: "language",
        },
        {
          text: this.$t("dashboard.menu.eventDetails.comments"),
          groupable: false,
          value: "comments",
        },
        {
          text: this.$t("dashboard.menu.eventDetails.actions"),
          groupable: false,
          value: "organizationName",
        },
      ];
    }, 
    items_L() {
      return [
        this.$t("dashboard.menu.eventDetails.english"), 
        this.$t("dashboard.menu.eventDetails.french")
      ];
    },
    optionListItems() {
      return [
        { id: 0, text: this.$t("dashboard.menu.eventDetails.mandatory") },
        { id: 1, text: this.$t("dashboard.menu.eventDetails.optional") },
      ];
    }
  },
  asyncComputed: {
    organizationListItems: async function () {
      var response = await this.api("get", "/api/v1/promoter/eventDetails/getOrganizationList2");

      return response.message;
    },
    eventOrganization: async function () {
      var response = await this.api("get", "/api/v1/promoter/eventDetails/getEventOrganization/" + this.$route.params.id);

      return response.message;
    },
  },
  methods: {
    async getEventOrganization() {
      var response_ = await this.api("get", "/api/v1/promoter/eventDetails/getEventOrganization/" + this.$route.params.id);
      
      return response_.message;
    },
    deleteOrgTap() {
      this.items_ = [];
      this.information = [];
      this.optionList = [];
      this.forceWaiverSignature = [];
      this.count = 0;
      this.organizationList = null;
      this.tab = null;
      this.tab_ = null;
    },
    async deleteOrganization() {
      let data_ = {};

      data_.eventOrganizationId = this.itemUpdate[0].eventOrganizationId;
      data_.eventId = this.$route.params.id;
      data_.action = "removeEventOrganization";

      const response = await this.postApi("/api/v1/promoter/eventDetails/eventOrganization", data_);

      if (response.success == 1) this.eventOrganization = await this.getEventOrganization();

      this.close();
    },
    async editChanges() {

      this.dialog = false;

      let data_ = {};
      data_.organizationEvent = {};
      data_.organizationEvent.id = this.itemUpdate[0].eventOrganizationId;
      data_.organizationEvent.isRequestMemberInfo = this.optionList[0].text;
      data_.organizationEvent.organization = this.items_[0].value;
      data_.organizationEvent.organizationId = this.items_[0].id;
      data_.organizationEvent.isForceWaiverSignature = this.forceWaiverSignature[0] ? 1 : 0;
      data_.organizationEvent.eventOrgTranslation = {};
      data_.organizationEvent.eventOrgTranslation.en = {};
      data_.organizationEvent.eventOrgTranslation.en.id = this.itemUpdate[0].translateId;
      data_.organizationEvent.eventOrgTranslation.en.languageName = "English";
      data_.organizationEvent.eventOrgTranslation.en.membersAddInfo = this.information[0][0] != undefined ? this.information[0][0] : "";
      data_.organizationEvent.eventOrgTranslation.fr = {};
      data_.organizationEvent.eventOrgTranslation.fr.id = this.itemUpdate[1].translateId;
      data_.organizationEvent.eventOrgTranslation.fr.languageName = "Français";
      data_.organizationEvent.eventOrgTranslation.fr.membersAddInfo = this.information[0][1] != undefined ? this.information[0][1] : "";
      data_.eventId = this.$route.params.id;
      data_.action = "addOrganization";

      const response = await this.postApi("/api/v1/promoter/eventDetails/eventOrganization", data_);

      if (response.success == 1) this.eventOrganization = await this.getEventOrganization();
      this.close();
    },
    async handleSubmit() {
      this.dialog = false;

      if (this.information.length != 0 && this.optionList.length != 0 && this.items_.length != 0) {
        for (var i = 0; i < this.items_.length; i++) {
          let data_ = {};
          data_.organizationEvent = {};
          data_.organizationEvent.id = "";
          data_.organizationEvent.isRequestMemberInfo = this.optionList[i].text;
          data_.organizationEvent.organization = this.items_[i].value;
          data_.organizationEvent.organizationId = this.items_[i].id;
          data_.organizationEvent.isForceWaiverSignature = this.forceWaiverSignature[i] ? 1 : 0;
          data_.organizationEvent.eventOrgTranslation = {};
          data_.organizationEvent.eventOrgTranslation.en = {};
          data_.organizationEvent.eventOrgTranslation.en.id = "";
          data_.organizationEvent.eventOrgTranslation.en.languageName = "";
          data_.organizationEvent.eventOrgTranslation.en.membersAddInfo = this.information[i][0] != undefined ? this.information[i][0] : "";
          data_.organizationEvent.eventOrgTranslation.fr = {};
          data_.organizationEvent.eventOrgTranslation.fr.id = "";
          data_.organizationEvent.eventOrgTranslation.fr.languageName = "";
          data_.organizationEvent.eventOrgTranslation.fr.membersAddInfo = this.information[i][1] != undefined ? this.information[i][1] : "";
          data_.eventId = this.$route.params.id;
          data_.action = "addOrganization";

          const response = await this.postApi("/api/v1/promoter/eventDetails/eventOrganization", data_);

          if (response.success == 1) this.eventOrganization = await this.getEventOrganization();

          this.items_ = [];
        }
      }
    },
    add() {
      if (this.organizationList != null && !this.items_.some((item) => item.value === this.organizationList.value)) {
        this.tab = null; // add this new line
        this.items_.push({
          value: this.organizationList.value,
          id: this.organizationList.id,
        });
        this.information[this.count] = [];
        this.optionList[this.count] = {
          id: 1,
          text: this.$t("dashboard.menu.eventDetails.optional"),
        };
        this.forceWaiverSignature[this.count] = false;
        this.count++;
      }
    },
    close() {
      this.dialog = false;
      this.items_ = [];
      this.information = [];
      this.optionList = [];
      this.forceWaiverSignature = [];
      this.count = 0;
      this.organizationList = null;
      this.tab = null;
      this.tab_ = null;

      this.create = true;
      this.edit_ = false;
    },
    edit(item, tab) {
      this.dialog = true;
      this.create = false;
      this.edit_ = true;
      this.itemUpdate = item;

      this.tab_ = tab; // add this new line
      let item_add = {
        value: item[0].organizationName,
        id: item[0].organizationId,
      };
      const arrayFilter = this.items_.filter((elem) => {
        return elem.value === item_add.value && elem.id === item_add.id;
      });
      if(arrayFilter.length === 0) this.items_.push(item_add);
      this.information[0] = [];
      this.information[0][0] = item[0].comments;
      this.information[0][1] = item[1].comments;
      this.optionList[0] = {
        id: item[0].isRequestMemberInfo == "Optional" ? 1 : 0,
        text: item[0].isRequestMemberInfo == "Optional" ? this.$t("dashboard.menu.eventDetails.optional") : this.$t("dashboard.menu.eventDetails.mandatory"),
      };
      this.forceWaiverSignature[0] = Number(item[0].isForceWaiverSignature || 0) === 1;
    },
  },
};
</script>

<style>
.v-application .ma-2 {
  margin: 1px !important;
}
.v-tab--active {
  color: #555555 !important;
  background-color: #ccc;
}
@media (max-width: 1024px) {
  .subtitule2 {
    padding-bottom: 13% !important;
  }
}
</style>
